import { render, staticRenderFns } from "./AddSSOConfig.vue?vue&type=template&id=0944d892"
import script from "./AddSSOConfig.vue?vue&type=script&lang=js"
export * from "./AddSSOConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports